import H from "@babel/runtime/helpers/esm/objectSpread2";
import W from "@babel/runtime/helpers/esm/classCallCheck";
import F from "@babel/runtime/helpers/esm/createClass";
import g from "@babel/runtime/helpers/esm/assertThisInitialized";
import L from "@babel/runtime/helpers/esm/inherits";
import N from "@babel/runtime/helpers/esm/createSuper";
import s from "@babel/runtime/helpers/esm/defineProperty";
import D from "@babel/runtime/helpers/esm/extends";
import U from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { sstyled as j } from "@semcore/utils/lib/core/index";
import q, { sstyled as M, assignProps as V, Component as G } from "@semcore/core";
import f from "react";
import { findDOMNode as J } from "react-dom";
import { Box as $ } from "@semcore/flex-box";
import R from "@semcore/utils/lib/rafTrottle";
import { getNodeByRef as k } from "@semcore/utils/lib/ref";
import { isAdvanceMode as K } from "@semcore/utils/lib/findComponent";
import { callAllEventHandlers as B } from "@semcore/utils/lib/assignProps";
import Q, { setAreaValue as X } from "./ScrollBar.mjs";
import E from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import Y from "@semcore/utils/lib/uniqueID";
import Z from "@semcore/utils/lib/canUseDOM";
var tt = ["position"], et = (
  /*__reshadow_css_start__*/
  (j.insert(
    /*__inner_css_start__*/
    `.___SScrollArea_ytl74_gg_{position:relative;width:100%;height:100%}.___SShadowHorizontal_ytl74_gg_:after,.___SShadowHorizontal_ytl74_gg_:before,.___SShadowVertical_ytl74_gg_:after,.___SShadowVertical_ytl74_gg_:before{content:"";position:absolute;display:none;pointer-events:none}.___SShadowHorizontal_ytl74_gg_:after,.___SShadowHorizontal_ytl74_gg_:before{top:0;width:5px;height:100%}.___SShadowHorizontal_ytl74_gg_._position_median_ytl74_gg_:before{left:0;display:block;background:var(--intergalactic-scroll-area-shadow-left,
    linear-gradient(to right, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowHorizontal_ytl74_gg_._position_median_ytl74_gg_:after{right:0;display:block;background:var(--intergalactic-scroll-area-shadow-right,
    linear-gradient(to left, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowHorizontal_ytl74_gg_._position_start_ytl74_gg_:before{left:0;display:block;background:var(--intergalactic-scroll-area-shadow-left,
    linear-gradient(to right, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowHorizontal_ytl74_gg_._position_end_ytl74_gg_:after{right:0;display:block;background:var(--intergalactic-scroll-area-shadow-right,
    linear-gradient(to left, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowHorizontal_ytl74_gg_.__leftOffset_ytl74_gg_:before{left:var(--leftOffset_ytl74)}.___SShadowHorizontal_ytl74_gg_.__rightOffset_ytl74_gg_:after{right:var(--rightOffset_ytl74)}.___SShadowVertical_ytl74_gg_:after,.___SShadowVertical_ytl74_gg_:before{left:0;width:100%;height:5px}.___SShadowVertical_ytl74_gg_._position_median_ytl74_gg_:before{top:0;display:block;background:var(--intergalactic-scroll-area-shadow-top,
    linear-gradient(to bottom, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowVertical_ytl74_gg_._position_median_ytl74_gg_:after{bottom:0;display:block;background:var(--intergalactic-scroll-area-shadow-bottom,
    linear-gradient(to top, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowVertical_ytl74_gg_._position_start_ytl74_gg_:before{top:0;display:block;background:var(--intergalactic-scroll-area-shadow-top,
    linear-gradient(to bottom, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowVertical_ytl74_gg_._position_end_ytl74_gg_:after{bottom:0;display:block;background:var(--intergalactic-scroll-area-shadow-bottom,
    linear-gradient(to top, rgba(25, 27, 35, 0.1) 20.55%, rgba(255, 255, 255, 0.0001) 100%))}.___SShadowVertical_ytl74_gg_.__topOffset_ytl74_gg_:before{top:var(--topOffset_ytl74)}.___SShadowVertical_ytl74_gg_.__bottomOffset_ytl74_gg_:after{bottom:var(--bottomOffset_ytl74)}.___SContainer_ytl74_gg_{display:block;width:100%;height:100%;box-sizing:content-box;overflow:auto;-webkit-overflow-scrolling:touch;outline:0;scrollbar-width:none;-ms-overflow-style:none}.___SContainer_ytl74_gg_::-webkit-scrollbar{display:none}.___SContainer_ytl74_gg_.__keyboardFocused_ytl74_gg_:focus::after{position:absolute;display:block;content:"";top:0;right:0;bottom:0;left:0;top:var(--focusRingTopOffset_ytl74);right:var(--focusRingRightOffset_ytl74);bottom:var(--focusRingBottomOffset_ytl74);left:var(--focusRingLeftOffset_ytl74);box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5));pointer-events:none;z-index:2}`,
    "ytl74_gg_"
  ), {
    __SScrollArea: "___SScrollArea_ytl74_gg_",
    __SShadowHorizontal: "___SShadowHorizontal_ytl74_gg_",
    _leftOffset: "__leftOffset_ytl74_gg_",
    "--leftOffset": "--leftOffset_ytl74",
    _rightOffset: "__rightOffset_ytl74_gg_",
    "--rightOffset": "--rightOffset_ytl74",
    __SShadowVertical: "___SShadowVertical_ytl74_gg_",
    _topOffset: "__topOffset_ytl74_gg_",
    "--topOffset": "--topOffset_ytl74",
    _bottomOffset: "__bottomOffset_ytl74_gg_",
    "--bottomOffset": "--bottomOffset_ytl74",
    __SContainer: "___SContainer_ytl74_gg_",
    _keyboardFocused: "__keyboardFocused_ytl74_gg_",
    "--focusRingTopOffset": "--focusRingTopOffset_ytl74",
    "--focusRingRightOffset": "--focusRingRightOffset_ytl74",
    "--focusRingBottomOffset": "--focusRingBottomOffset_ytl74",
    "--focusRingLeftOffset": "--focusRingLeftOffset_ytl74",
    _position_median: "_position_median_ytl74_gg_",
    _position_start: "_position_start_ytl74_gg_",
    _position_end: "_position_end_ytl74_gg_"
  })
), A = void 0;
typeof window < "u" && (A = new Event("calculate"));
var P = /* @__PURE__ */ f.forwardRef(function(h, v) {
  h.position;
  var p = U(h, tt);
  return /* @__PURE__ */ f.createElement($, D({
    ref: v
  }, p));
}), O = /* @__PURE__ */ function(h) {
  L(p, h);
  var v = N(p);
  function p(d) {
    var t;
    return W(this, p), t = v.call(this, d), s(g(t), "$wrapper", null), s(g(t), "observer", null), s(g(t), "horizontalBarRef", /* @__PURE__ */ f.createRef()), s(g(t), "verticalBarRef", /* @__PURE__ */ f.createRef()), s(g(t), "state", {
      shadowHorizontal: !1,
      shadowVertical: !1
    }), s(g(t), "refWrapper", function(e) {
      t.$wrapper = J(e);
    }), s(g(t), "setStyleSizeProperty", function(e, o, r) {
      var i = r;
      typeof r == "number" && (i = r < 1 ? "".concat(100 * r, "%") : "".concat(r, "px")), e.style.setProperty(o, i);
    }), s(g(t), "calculate", R(function() {
      if (t.$container) {
        var e = t.calculateSizeContainer(), o = e.height, r = e.width;
        o && (t.$container.style.height = o), r && (t.$container.style.width = r), t.$container.dispatchEvent(A), t.setShadowContainer();
      }
    })), s(g(t), "updateBarsAria", R(function() {
      X(t.$container, t.horizontalBarRef.current, t.verticalBarRef.current);
    })), s(g(t), "handleScrollContainer", R(function() {
      t.$container && (t.setShadowContainer(), t.updateBarsAria());
    })), s(g(t), "handleScroll", function(e) {
      var o;
      (o = e.target) !== null && o !== void 0 && o.isEqualNode(t.$wrapper) && (e.target.scrollTop = 0, e.target.scrollLeft = 0);
    }), s(g(t), "handleFocusIn", function(e) {
      setTimeout(function() {
        var o = t.asProps, r = o.keyboardFocused, i = o.leftOffset, a = o.rightOffset, _ = o.topOffset, u = o.bottomOffset;
        if (t.$container && typeof t.$container.scrollTo == "function") {
          var l = t.$container.getBoundingClientRect(), n = e.target.getBoundingClientRect(), c = {
            top: _ ?? 0,
            left: i ?? 0,
            right: a ?? 0,
            bottom: u ?? 0
          };
          if (l) {
            var y = Math.floor(n.top) >= l.bottom - c.bottom || Math.floor(n.bottom) <= l.top + c.top || Math.floor(n.left) >= l.right - c.right || Math.floor(n.right) <= l.left + c.left;
            y && r && t.$container.scrollTo({
              top: n.top + t.$container.scrollTop - c.top - l.top,
              left: n.left + t.$container.scrollLeft - c.left - l.left
            });
          }
        }
      }, 0);
    }), s(g(t), "toggleShadow", function(e, o, r) {
      var i = Math.round(e), a = Math.round(o), _ = "";
      a <= 0 || (i <= 0 ? _ = "end" : i >= a ? _ = "start" : i > 0 && (_ = "median")), t.setState(s({}, r, _));
    }), s(g(t), "setShadowContainer", function() {
      if (!(!t.asProps.shadow || !t.$container || !t.$wrapper)) {
        var e = t.$container, o = e.scrollWidth, r = e.clientWidth, i = e.scrollHeight, a = e.clientHeight, _ = e.scrollLeft, u = e.scrollTop, l = o - r, n = i - a;
        t.toggleShadow(_, l, "shadowHorizontal"), t.toggleShadow(u, n, "shadowVertical");
      }
    }), Z() && (t.observer = new ResizeObserver(B(d.onResize, t.calculate))), t;
  }
  return F(p, [{
    key: "$container",
    get: function() {
      return k(this.asProps.container);
    }
  }, {
    key: "$inner",
    get: function() {
      return k(this.asProps.inner);
    }
  }, {
    key: "calculateSizeContainer",
    value: (
      // for max height/width
      function() {
        var t = this.asProps, e = t.wMax, o = t.hMax, r = t.observeParentSize, i = {
          width: "",
          height: ""
        };
        if (!this.$container || !this.$wrapper) return i;
        var a = this.$container, _ = a.scrollWidth, u = a.scrollHeight, l = window.getComputedStyle(this.$wrapper), n = this.$wrapper.parentElement, c = {
          width: 0,
          height: 0
        };
        r && (n && (c = n.getBoundingClientRect()), e && this.setStyleSizeProperty(this.$wrapper, "max-width", e), o && this.setStyleSizeProperty(this.$wrapper, "max-height", o));
        var y = Number.parseInt(l.getPropertyValue("max-width")), m = Number.parseInt(l.getPropertyValue("max-height"));
        if (y) {
          if (r && e && n.scrollWidth > c.width) {
            var S = Math.round(n.scrollWidth.toFixed(1)) - Math.round(c.width.toFixed(1));
            S < y && (y = y - S, this.$wrapper.style.setProperty("max-width", "".concat(y, "px")));
          }
          _ > y ? i.width = "".concat(y, "px") : i.width = "100%";
        }
        if (m) {
          if (r && o && n.scrollHeight > c.height) {
            var b = Math.round(n.scrollHeight.toFixed(1)) - Math.round(c.height.toFixed(1));
            b < m && (m = m - b, this.$wrapper.style.setProperty("max-height", "".concat(m, "px")));
          }
          u > m ? i.height = "".concat(m, "px") : i.height = "100%";
        }
        return i;
      }
    )
  }, {
    key: "getContainerProps",
    value: function() {
      var t = this.asProps, e = t.container, o = t.inner, r = t.onScroll, i = t.uid;
      return {
        id: "igc-".concat(i, "-scroll-container"),
        ref: e,
        $refInner: o,
        onScroll: B(r, this.handleScrollContainer)
      };
    }
  }, {
    key: "getBarProps",
    value: function() {
      var t = this.asProps, e = t.container, o = t.orientation, r = t.uid, i = t.leftOffset, a = t.rightOffset;
      return {
        container: e,
        orientation: o,
        uid: r,
        horizontalBarRef: this.horizontalBarRef,
        verticalBarRef: this.verticalBarRef,
        leftOffset: i,
        rightOffset: a
      };
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var t;
      if (this.calculate(), this.updateBarsAria(), this.$inner) {
        var e;
        (e = this.observer) === null || e === void 0 || e.observe(this.$inner);
      }
      if (this.$container) {
        var o;
        (o = this.observer) === null || o === void 0 || o.observe(this.$container);
      }
      (t = this.$inner) === null || t === void 0 || t.addEventListener("focusin", this.handleFocusIn);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.calculate();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      var t, e;
      (t = this.observer) === null || t === void 0 || t.disconnect(), (e = this.$inner) === null || e === void 0 || e.removeEventListener("focusin", this.handleFocusIn);
    }
  }, {
    key: "render",
    value: function() {
      var t = this.asProps, e, o = $, r = P, i = P, a = this.asProps, _ = a.Children, u = a.styles, l = a.orientation, n = a.tabIndex, c = a.forcedAdvancedMode, y = a.leftOffset, m = a.rightOffset, S = a.topOffset, b = a.bottomOffset, x = this.state, z = x.shadowVertical, C = x.shadowHorizontal, T = c || K(_, [w.Container.displayName, w.Bar.displayName]);
      return e = M(u), /* @__PURE__ */ f.createElement(o, e.cn("SScrollArea", H({}, V({
        ref: this.refWrapper,
        onScroll: this.handleScroll,
        __excludeProps: ["tabIndex"]
      }, t))), T ? /* @__PURE__ */ f.createElement(_, e.cn("Children", {})) : /* @__PURE__ */ f.createElement(f.Fragment, null, /* @__PURE__ */ f.createElement(w.Container, {
        tabIndex: n
      }, /* @__PURE__ */ f.createElement(_, e.cn("Children", {}))), (l === void 0 || l === "horizontal") && /* @__PURE__ */ f.createElement(w.Bar, {
        orientation: "horizontal"
      }), (l === void 0 || l === "vertical") && /* @__PURE__ */ f.createElement(w.Bar, {
        orientation: "vertical"
      })), z && /* @__PURE__ */ f.createElement(r, e.cn("SShadowVertical", {
        position: z,
        topOffset: S ? "".concat(S, "px") : void 0,
        bottomOffset: b ? "".concat(b, "px") : void 0
      })), C && /* @__PURE__ */ f.createElement(i, e.cn("SShadowHorizontal", {
        position: C,
        leftOffset: y ? "".concat(y, "px") : void 0,
        rightOffset: m ? "".concat(m, "px") : void 0
      })));
    }
  }]), p;
}(G);
s(O, "displayName", "ScrollArea");
s(O, "style", et);
s(O, "enhance", [Y(), E()]);
s(O, "defaultProps", function() {
  return {
    container: /* @__PURE__ */ f.createRef(),
    inner: /* @__PURE__ */ f.createRef(),
    tabIndex: 0,
    observeParentSize: !1
  };
});
function I(h) {
  var v = arguments[0], p, d = $, t = h.Children, e = h.styles, o = h.$refInner, r = h.focusRingTopOffset, i = r === void 0 ? 0 : r, a = h.focusRingRightOffset, _ = a === void 0 ? 0 : a, u = h.focusRingBottomOffset, l = u === void 0 ? 0 : u, n = h.focusRingLeftOffset, c = n === void 0 ? 0 : n;
  return p = M(e), /* @__PURE__ */ f.createElement(d, p.cn("SContainer", H({}, V({
    tabIndex: 0,
    focusRingTopOffset: i,
    focusRingRightOffset: _,
    focusRingBottomOffset: l,
    focusRingLeftOffset: c
  }, v))), /* @__PURE__ */ f.createElement("div", p.cn("div", {
    ref: o
  }), /* @__PURE__ */ f.createElement(t, p.cn("Children", {}))));
}
I.enhance = [E()];
var w = q(O, {
  Container: I,
  Bar: Q
});
export {
  w as ScrollArea,
  w as default,
  A as eventCalculate
};
